const typeConversionTable = {
  accountManagement: 'A_ACCOUNT_MANAGEMENT',
  admin: 'ADMIN',
  betaAccess: 'BETA_ACCESS',
  demo: 'DEMO',
  dev: 'DEV',
  export: 'EXPORT',
  exportToEmail: 'EXPORT_TO_EMAIL',
  free: 'FREE',
  grantPrivileges: 'A_GRANT_PRIVILEGES',
  loginAs: 'A_LOGIN_AS', // represent that user could start a session in "login as"
} as const

type Privilege = keyof typeof typeConversionTable

export type ExtendedPrivilege = Privilege | 'loginAsPasspartout'

const convertPrivilege = (privilege: Privilege): uui.domain.server.rm.UserPrivilege => {
  const convertedValue = typeConversionTable?.[privilege]

  if (!convertedValue && process.env.NODE_ENV === 'development') {
    throw new Error(`Unknown privilege ${privilege}`)
  }

  return convertedValue
}

function includesPrivilege(
  privileges: uui.domain.server.rm.UserPrivilege[],
  privilegeToCheck: ExtendedPrivilege,
  isLoginAs: boolean, // user is in a "login as" session
) {
  if (privilegeToCheck === 'loginAsPasspartout') {
    return isLoginAs
  }
  return privileges.includes(convertPrivilege(privilegeToCheck))
}

export const checkPrivileges = (
  userPrivileges: uui.domain.server.rm.UserPrivilege[],
  accountPrivileges: ExtendedPrivilege[],
  exactPrivileges: boolean,
  isLoginAs: boolean, // user is in a "login as" session
) => {
  return exactPrivileges
    ? accountPrivileges.every(privilege => includesPrivilege(userPrivileges, privilege, isLoginAs))
    : accountPrivileges.some(privilege => includesPrivilege(userPrivileges, privilege, isLoginAs))
}
